function directive() {
    return {
        link: function ($scope, element, attrs) {
            var sev = attrs.name;

            var elm = d3.select(element[0])
                .append('svg')
                .attr('x',0)
                .attr('y',0)
                .attr('width','44px')
                .attr('height','44px')
                // .attr('viewBox','0 0 42.795 42.795')
                // .attr('enable-background','new 0 0 42.795 42.795')
                .attr('xml:space','preserve');

            // switch between icon
            switch (sev) {
                case '1':
                    elm.append('circle')
                        .attr('cx', 24)
                        .attr('cy', 24)
                        .attr('r', 14)
                        .attr('stroke-width', 1)
                        .style('fill', '#377FC7');
                    elm.append('polygon')
                        .attr('points', '9,1 8,0 0,0 0,18 2,18 2,10 7,10 8,11 14,11 14,1 ')
                        .style('fill', '#333')
                        .attr('transform', 'translate(19,17), scale(0.8)');
                    return;
                case '2':
                    elm.append('circle')
                        .attr('cx', 24)
                        .attr('cy', 24)
                        .attr('r', 14)
                        .attr('stroke-width', 1)
                        .style('fill', '#F5D800');
                    elm.append('polygon')
                        .attr('points', '3.6,0 3.6,2 12.4,2 0,14.4 1.4,15.8 13.6,3.6 13.6,12 15.6,12 15.6,0 ')
                        .style('fill', '#333')
                        .attr('transform', 'translate(18,18), scale(0.8)');
                    return;
                case '3':
                    elm.append('circle')
                        .attr('cx', 24)
                        .attr('cy', 24)
                        .attr('r', 14)
                        .attr('stroke-width', 1)
                        .style('fill', '#F88B12');
                    elm.append('path')
                        .attr('d', 'M17.7,17H0c0.5-1.3,1.3-2.5,2.3-3.4V8h0c0.2-2.9,2.3-5.3,5.1-5.9C7.4,1.9,7.3,1.7,7.3,1.5C7.3,0.7,8,0,8.8,0'+
                        's1.5,0.7,1.5,1.5c0,0.2-0.1,0.4-0.2,0.6c2.8,0.6,4.9,3,5.1,5.9h0v5.6C16.3,14.5,17.1,15.7,17.7,17z M8.8,20c1.2,0,2.2-0.9,2.4-2H6.4')
                        .style('fill', '#333')
                        .attr('transform', 'translate(17,16), scale(0.8)');
                    return;
                case '4':
                    elm.append('circle')
                        .attr('cx', 24)
                        .attr('cy', 24)
                        .attr('r', 14)
                        .attr('stroke-width', 1)
                        .style('fill', '#FF3131');
                    elm.append('path')
                        .attr('d', 'M12.7,0H5.3L0,5.3v7.5L5.3,18h7.5l5.3-5.3V5.3L12.7,0z M10,14H8v-2h2V14z M10,10H8V4h2V10z')
                        .style('fill', '#333')
                        .attr('transform', 'translate(17,17), scale(0.8)');
                    return;
                default:
                    return;
            }
        }
    }
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sevreplace/sevreplace.js
 **/